<script>
import BaseButtonElement from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";
import Label from "%/dynamic-component-editor/options/label";
import { LabelButtonMixin } from "%/dynamic-component-editor/standard-components/plan-sheet/label-button-mixin";

// Restores App Store purchases. Only an iOS app can restore, so the web renders
// nothing; the canvas shows it so authors can style it.
export default {
  name: "RestorePurchasesButton",
  extends: BaseButtonElement,
  mixins: [LabelButtonMixin],
  elementPanelSettings: {
    displayName: "Restore Purchases",
    displayIcon: "button",
    elementType: "element",
    tags: ["payments", "restore", "app store"],
  },
  options: [
    new Label({ "default": "Restore purchases" }),
  ],
  computed: {
    shouldRenderButton() {
      return this.editMode;
    },
  },
  methods: {
    handleButtonClick() {},
  },
};
</script>
